import * as React from "react";
import { Edit, SimpleForm, TextInput, required } from "react-admin";
import { useClub } from "../club/ClubContext";
import { useNavigate } from "react-router-dom";
import { Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export function TeamEdit() {
  const { clubId } = useClub();
  const navigate = useNavigate();

  return (
    <Box p={2}>
      <Box mb={2}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate("/teams")}>
          Zurück zur Teamliste
        </Button>
      </Box>

      <Edit
        // sorgt dafür, dass club_id beim Speichern garantiert gesetzt ist
        transform={(data) => ({
          ...data,
          club_id: data.club_id ?? clubId,
        })}
      >
        <SimpleForm>
          <TextInput source="name" validate={[required()]} fullWidth />

          {/* club_id nicht editierbar – aber im Payload enthalten */}
          <TextInput source="club_id"sx={{ display: "none" }} />
        </SimpleForm>
      </Edit>
    </Box>
  );
}
